import { IconProps } from "../../utils/global-types/global-types";

const MoveInIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 18 18"
      className={className ? className : "w-[18px] h-[18px]"}
      {...rest}
    >
      <path
        fill="currentColor"
        d="M9.25 2.5a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25H7v1.75a.25.25 0 0 1-.25.25h-.5A.25.25 0 0 1 6 5.25V3.5a1 1 0 0 1 1-1zM7 12.75v1.75h2.25a.25.25 0 0 1 .25.25v.5a.25.25 0 0 1-.25.25H7a1 1 0 0 1-1-1v-1.75a.25.25 0 0 1 .25-.25h.5a.25.25 0 0 1 .25.25M2 9.5v-1a.25.25 0 0 1 .25-.25H7V6.677c0-.065.079-.098.125-.052l2.319 2.319c.03.03.03.08 0 .111l-2.319 2.32A.073.073 0 0 1 7 11.323V9.75H2.25A.25.25 0 0 1 2 9.5M15.61 3.427l-4.756-1.416a.273.273 0 0 0-.354.257v13.46c0 .182.18.313.358.26l4.752-1.415a.54.54 0 0 0 .39-.515V3.942a.54.54 0 0 0-.39-.515M12.5 9.5a.5.5 0 1 1-1 0v-1a.5.5 0 1 1 1 0z"
      ></path>
    </svg>
  );
};

export default MoveInIcon;
